import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import useAxiosFetch from "../common/useAxiosFetch";
import { useTranslation } from 'react-i18next';
import DualThumbSlider from "../common/DualThumbSlider";
import { getRiskColor, DEFAULT_RANGE_BOUNDS } from "../common/helpers";


const OrganizationForm = ({register, onSubmit, handleSubmit, text, orgData, setValue, currentUser}) => {
  const { t } = useTranslation();
  const [bounds, setBounds] = useState(DEFAULT_RANGE_BOUNDS);
  const { data: users, loading } = useAxiosFetch("/api/users/");

  useEffect(() => {
    if (orgData) {
      setValue("name", orgData.name);
      setValue("description", orgData.description);
      setValue("securityStandard", orgData.securityStandard);
      setValue("ownerUserId", orgData.ownerUserId);
      
      if(orgData.rangeBounds) {
        setBounds(orgData.rangeBounds);
      }
    }
  }, [orgData]);

  const impacts = [1, 2, 3, 4, 5];
  const chances = [1, 2, 3, 4, 5];

  const getColor = (score) => getRiskColor(score, bounds);

  if(loading)
    return <div>Loading...</div>;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Form.Group className="mb-3">
        <Form.Label>{t('organization')} {t('name').toLowerCase()}</Form.Label>
        <Form.Control {...register("name")} as="input" name="name" required />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>{t('owner_without_prefix')}</Form.Label>
        <Form.Select {...register("ownerUserId")}  name="ownerUserId" defaultValue={currentUser.user_id} >
          {
          // filter out users with role='user'
          users.filter((user) => user.role !== 'user').map((user) => {
            return (
              <option key={user["id"]} value={user["id"]}>
                {user.name}
              </option>
            );
          })}

        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3">
          <Form.Label>{t('company_info')}</Form.Label>
          <Form.Control {...register("description")} as="textarea" rows={3} name="description" placeholder={t('company_info_placeholder')}  />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>{t('security_standard')}</Form.Label>
        <Form.Select {...register("securityStandard")}  name="securityStandard" defaultValue={orgData?.securityStandard || "ISO27001"}>
          <option value="ISO27001">ISO27001</option>
          <option value="NEN7510">NEN7510</option>
          <option value="ISO42001">ISO42001</option>
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>{t('risk_appetite')}</Form.Label>
        <DualThumbSlider
          value={bounds}
          min={1}
          max={25}
          onChange={(newBounds) => {
            setBounds(newBounds);
            // Convert the new bounds to a string for form state if needed
            setValue("rangeBounds", newBounds.toString());
          }}
        />
        <input type="hidden" {...register("rangeBounds")} name="rangeBounds" defaultValue={bounds} />
      
      </Form.Group>
        <table>
        <thead>
          <tr style={{height: 50}}>
            <th/>
            <th/>
            <th colSpan={chances.length} style={{textAlign: 'center', fontWeight: 'bold'}}>{t('chance')}</th>
          </tr>
          <tr>
              <th/>
              <th/>
            {chances.map((chance, i) => (
              <th style={{height: 50, lineHeight: '50px', textAlign: "center"}} key={i}>{chance}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {impacts.map((impact, i) => (
            <tr key={i}>
              {i === 0 && 
                <td rowSpan={impacts.length} width="50" style={{border: 0}}>
                  <div style={{transform: 'rotate(-90deg)', width: '1px', height: '20px', position: 'relative', left: '50%'}}>
                    <span style={{fontWeight: 'bold', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>{t('impact')}</span>
                  </div>
                </td>
              }
              <td style={{fontWeight: 'bold', border: 0}}>{impact}</td>
              {chances.map((chance, j) => {
                const score = impact * chance;
                return (
                  <td key={j} className={"risk-score-" + getColor(score)}>{score}</td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>

      <div className="vertical-spacer" />

      <input className="white-border-btn submit-btn" type="submit" value={text} />

    </form>
  );
};

export default OrganizationForm;